import Skeleton, { SkeletonProps } from '@material-ui/lab/Skeleton'

export interface Props extends SkeletonProps {
  // No additional props defined
}

export default function (props: Props) {
  return <Skeleton {...props} />
}
